import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { FooterPopups } from './footer-popups/footer-popups';

@Component({
  selector: 'app-footer',
  imports: [NgOptimizedImage, FooterPopups],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {}
